import { RECEIVE_RETURNS_SETTINGS } from '../../actions/returnsSettings';

export default (state = {}, { type, data: { returnsSettings = {} } = {} } = {}) => {
  switch (type) {
    case RECEIVE_RETURNS_SETTINGS:
      return { ...state, ...returnsSettings };

    default:
      return state;
  }
};
